import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { externalLinkOpen } from '../../../../actions/externallink';
import { RedirectServices, getRedirectUrl } from '../../../../config/urls';
import useMergeProps from '../../../../hooks/useMergeProps';
import { StateType } from '../../../../states';
import { selectGRGlobalSkinId } from '../../selectors/global/globalPrimary.selector';
import type { GRRound as GRRoundType } from '../../types/round';

import GRRound from './GRRound';
import makeSelectGRRoundPropsSelector from './GRRound.selector';

type GRRound1ContainerProps = {
  className?: string;
  children?: React.ReactNode;
  roundId: GRRoundType;
};

const GRRoundContainer = (ownProps: GRRound1ContainerProps) => {
  const dispatch = useDispatch();
  const skinId = useSelector(selectGRGlobalSkinId);
  const selector = useMemo(() => makeSelectGRRoundPropsSelector(), []);
  const selectorProps = useMemo(() => ({ roundId: ownProps.roundId }), [ownProps.roundId]);
  const selectedProps = useSelector((state: StateType) => selector(state, selectorProps));

  const onVideoTutorialClick = useCallback(() => {
    dispatch(externalLinkOpen(getRedirectUrl(RedirectServices.GR_VIDEO_TUTORIAL, { skinId })));
  }, [dispatch, skinId]);

  const otherProps = useMemo(
    () => ({
      onVideoTutorialClick,
    }),
    [onVideoTutorialClick],
  );

  const enhancedProps = useMergeProps({ otherProps, ownProps, selectedProps });

  return <GRRound {...enhancedProps} />;
};

export default GRRoundContainer;
